import LoaderTipo from './LoaderTipo';
import initialState from '../../../store/initialState'

const LoaderReducer = (state = initialState.loader, action) => {
  if (action.type === LoaderTipo.data.SHOW_LOADER) {
    return {
      ...state,
      showLoader: action.payload.showLoader
    };
  }
  return state;
}

export default LoaderReducer;